import React from 'react';
import { useEffect } from 'react';

const About = () => {
    useEffect(() => {
        document.title = 'NASCAR — О компании';
    }, []);

    return <div className="page">
        <section>
            <h2>О нас</h2>
            <p>Наш магазин был создан с целью предложить качественные товары по доступным ценам, обеспечивая удобный и приятный процесс покупки для каждого клиента.</p>

            <h3>Наши ценности</h3>
            <p>Мы тщательно отбираем продукцию, чтобы предложить вам только самые качественные товары от проверенных поставщиков. Каждый товар проходит строгий контроль качества перед тем, как попасть на наши виртуальные полки.</p>
            <p>Ваше удовлетворение — наш главный приоритет. Мы всегда готовы помочь вам с выбором товара, ответить на любые вопросы и решить возникшие проблемы. Наша служба поддержки работает для вас 24/7.</p>
            <p>Мы гарантируем честные цены и полное соответствие товаров их описанию на сайте. Вы всегда знаете, за что платите, и можете быть уверены в безопасности своих данных.</p>

            <h3>Почему выбирают нас</h3>
            <p><strong>Широкий ассортимент.</strong> В нашем магазине представлен широкий выбор товаров различных категорий. Мы регулярно обновляем ассортимент, чтобы вы могли найти самые актуальные новинки.</p>
            <p><strong>Удобство покупок.</strong> Современный и интуитивно понятный интерфейс нашего сайта позволяет легко находить нужные товары и оформлять заказы в несколько кликов.</p>
            <p><strong>Быстрая доставка.</strong> Мы сотрудничаем с надежными службами доставки, чтобы вы могли получить свои покупки в кратчайшие сроки. Мы предлагаем несколько вариантов доставки на ваш выбор.</p>
            <p><strong>Гарантии и возвраты.</strong> Мы уверены в качестве нашей продукции, поэтому предлагаем удобные условия возврата и обмена товаров.</p>

            <p>Если у вас есть вопросы, предложения или обратная связь, мы всегда рады вашему письму или звонку. Вы можете связаться с нами по электронной почте, телефону или через форму обратной связи на нашем сайте.</p>

            <p>Спасибо, что выбрали наш интернет-магазин. Приятных покупок!</p>

            <h4>ООО "БАУВЕРК"</h4>
            <p>УНП 193696124</p>

            <p>Режим работы интернет-магазина: с <strong>10:00</strong> до <strong>21:00</strong></p>
            <h3>Юридический адрес</h3>
            <p>РеспубликаБеларусь, 220020, г. Минск,<br />
                ул. Тимирязева, д. 97,<br />
                каб. 22-24</p>

            <h3>Почтовый адрес</h3>
            <p>РеспубликаБеларусь, 220020, г. Минск,<br />
                ул. Тимирязева, д. 97,<br />
                каб. 22-24</p>

            <h3>Банковские реквизиты</h3>
            <p>БИК: ALFABY2X<br />
                Р/СЧ: BY76ALFA30122D61350020270000<br />
                В ЗАО «Альфа-Банк», г. Минск,
                ул. Сурганова, 43-47</p>
        </section>
    </div>;
};

export default About;
